import React from "react";
import { motion } from "framer-motion";

const MainContentSection = () => {
  const contentData = {
    stats: "Curated Journeys. Shared Growth. Real Outcomes",
    title: "This is more than travel - this is transformation by design.",
    mainDescription: (
      <span className="text-blue text-2xl text-center tracking-[-1.00px] leading-[28.8px] font-bricolage">
        <span className="font-black drop-shadow-md">
          Outcome Outing is for the ones building something
        </span>{" "}
        — a business, a dream, a better version of themselves.
      </span>
    ),
    subTitle: "For those who seek clarity, connection, and change.",
    subDescription:
      "Each trip is guided by a mentor, powered by a community, and crafted to help you grow through shared stories, new perspectives, and purposeful travel.",
  };

  const textSections = [
    {
      type: "p",
      content: contentData.stats,
      className:
        "opacity-80 font-normal text-black text-base text-center leading-[22.4px] font-jakarta",
    },
    {
      type: "h1",
      content: contentData.title,
      className:
        "text-black text-3xl md:text-4xl text-center tracking-tight font-bold font-bricolage",
    },
    {
      type: "h3",
      content: contentData.subTitle,
      className:
        "text-gray-700 text-xl md:text-2xl text-center font-semibold font-bricolage",
    },
    {
      type: "h2",
      content: contentData.mainDescription,
      className:
        "text-center tracking-[-1.00px] leading-[28.8px] font-bricolage",
    },
    {
      type: "p",
      content: contentData.subDescription,
      className:
        "opacity-80 font-normal text-black text-base text-center leading-[22.4px] font-jakarta",
    },
  ];

  return (
    <section className="w-full py-16 bg-white">
      <div className="flex flex-col items-center gap-3 md:gap-3 max-w-3xl mx-auto px-4">
        {textSections.map((section, index) => {
          const Tag = section.type;

          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true, amount: 0.8 }}
            >
              <Tag className={section.className}>{section.content}</Tag>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default MainContentSection;
